import { useMemo } from 'react';

import {
  AlignCenterIcon,
  AlignJustify,
  AlignLeftIcon,
  AlignRightIcon,
  ArrowDownToLine,
  ArrowUpToLine,
  FlipVertical2,
  CaseLower,
  CaseSensitive,
  CaseUpper,
  Strikethrough,
  Underline,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalSpaceAround,
  MoveHorizontal,
  MoveVertical,
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
  GalleryHorizontal,
  ArrowRightToLine,
  Fullscreen,
  Maximize,
  SquareChartGantt,
  ExpandIcon,
  SquareIcon,
  RatioIcon,
  SquareRoundCorner,
  StretchVertical,
  StretchHorizontal,
  Columns3,
} from 'lucide-react';
import { DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui';

import { useCraftProp } from '../utils';

export default function ToggleGroupProperty({ name, type, options, defaultValue, onChange, ...props }) {
  const { value, setValue } = useCraftProp(name, defaultValue)

  const handleChange = value => {
    setValue(value)
    onChange && onChange(value)
  }

  const valueParsed = useMemo(() => type === 'multiple' ? value || [] : String(value) || '', [value, type])

  return <>
    <ToggleOptionGroup size='lg' value={valueParsed} type={type} onValueChange={handleChange} {...props}>
      {options.map(({ label, content, ...item }, idx) => <ToggleGroupItem key={idx} content={content || label} {...item} />)}
    </ToggleOptionGroup>
  </>
}

const ToggleGroupItem = ({ tooltip, value, content, icon, ...props }) => {
  const Tooltip = tooltip ? DefaultTooltip : 'span'

  return <>
    <ToggleOptionGroupItem value={String(value)} {...props}>
      <Tooltip content={tooltip} triggerProps={{ className: 'w-full flex justify-center' }}>
        {icon ? <Icon value={icon} /> : content}
      </Tooltip>
    </ToggleOptionGroupItem>
  </>
}

function Icon({ value }) {
  const Component = ICONS[value]
  return <Component size={14} />
}

const ICONS = {
  MoveHorizontal: MoveHorizontal,
  MoveVertical: MoveVertical,
  AlignVerticalJustifyStart: AlignVerticalJustifyStart,
  AlignVerticalSpaceAround: AlignVerticalSpaceAround,
  AlignVerticalJustifyEnd: AlignVerticalJustifyEnd,
  AlignHorizontalJustifyStart: AlignHorizontalJustifyStart,
  AlignHorizontalJustifyCenter: AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd: AlignHorizontalJustifyEnd,
  AlignHorizontalSpaceBetween: AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround: AlignHorizontalSpaceAround,
  StretchVertical: StretchVertical,
  StretchHorizontal: StretchHorizontal,
  Columns3: Columns3,
  GalleryHorizontal: GalleryHorizontal,
  ArrowRightToLine: ArrowRightToLine,
  Fullscreen: Fullscreen,
  Maximize: Maximize,
  SquareChartGantt: SquareChartGantt,

  CaseLower: CaseLower,
  CaseSensitive: CaseSensitive,
  CaseUpper: CaseUpper,
  Strikethrough: Strikethrough,
  Underline: Underline,

  AlignLeftIcon: AlignLeftIcon,
  AlignCenterIcon: AlignCenterIcon,
  AlignRightIcon: AlignRightIcon,
  AlignJustify: AlignJustify,
  ArrowUpToLine: ArrowUpToLine,
  FlipVertical2: FlipVertical2,
  ArrowDownToLine: ArrowDownToLine,
  all: SquareIcon,
  axis: RatioIcon,
  individual: ({ size }) => <ExpandIcon size={size} className='rotate-45' />,
  corners: SquareRoundCorner,
}
